import {ScheduleDto, SchedulePageDto,} from "../../../../types/schedule/schedule-dto";
import {convertScheduleDtoToSchedule} from "../../../../utils/converter/schedule/schedule-converter";
import {ScheduleState} from "../../../type/schedule-state";

interface Action {
    type: string;
    payload: {
        schedulePageAllDto: SchedulePageDto;
    };
}

export const setSchedulePageAllDispatch = (
    state: ScheduleState,
    action: Action
) => {
    const {schedulePageAllDto} = action.payload;

    state.schedulePageAll = {
        contents: schedulePageAllDto.contents.map((scheduleDto: ScheduleDto) => {
            return convertScheduleDtoToSchedule(scheduleDto);
        }),
        first: schedulePageAllDto.first,
        last: schedulePageAllDto.last,
        page: schedulePageAllDto.page,
        totalPages: schedulePageAllDto.totalPages,
        totalElements: schedulePageAllDto.totalElements,
    };
};
